import { Button } from "@/components/ui/button";

/**
 * Auto-NA affordance (session 73). Renders in place of a gated section's (or
 * category's) body when its situational gate is false. Warm, non-clinical copy
 * per decision 36.8 — nothing is hidden destructively; entered data is preserved
 * and one click away via "Mark as applicable".
 *
 * Presentational only: the caller wraps this in a TableRow/TableCell and owns
 * the situation-flags mutation behind `onMarkApplicable`.
 */
export function SectionNotApplicable({
  title,
  onMarkApplicable,
  isPending,
  readOnly,
}: {
  title: string;
  onMarkApplicable: () => void;
  isPending?: boolean;
  readOnly?: boolean;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-6 py-5">
      <p className="text-sm text-muted-foreground">
        The <span className="font-medium text-foreground">{title}</span> section is tucked
        away — it doesn&rsquo;t apply to you right now. Anything you entered is saved.
      </p>
      {!readOnly && (
        <Button
          variant="outline"
          size="sm"
          className="shrink-0 self-start sm:self-auto"
          onClick={onMarkApplicable}
          disabled={isPending}
          data-testid="button-mark-applicable"
        >
          {isPending ? "Updating…" : "Bring it back"}
        </Button>
      )}
    </div>
  );
}
